import App from './frontend-script/app';

const app = new App();
app.init();